import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Component } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: undefined
    };
  }
  static getDerivedStateFromError(error) {
    return {
      error
    };
  }
  render() {
    if (this.state.error) {
      return /*#__PURE__*/_jsx(ErrorMessage, {
        type: "badRequest"
      });
    }
    return this.props.children;
  }
}